<template>
  <div>
    <section>
      <header class="section-header where-we-ship-header">
        <h1>Where We Ship</h1>
      </header>
    </section>
    <section class="shipping-map">
      <client-only>
        <ShippingMap :states="metadata.settingsVars.COMPLIANCE_STATE_GROUPS" />
      </client-only>
      <ShippingStates :states="metadata.settingsVars.COMPLIANCE_STATE_GROUPS" />
    </section>
    <hr class="spacing" />
    <section class="generic">
      <p>
        Ground shipping is included on all orders of $150 or more, except for
        Alaska and Hawaii, and members will have 30 days to reach that
        threshold.
      </p>
      <p>
        To do so, purchase any bottle and we won't charge you for shipping at
        checkout. Instead, we’ll hold your wine for 30 days OR until your order
        reaches $150, whichever comes first. Once you hit $150, you’ll choose
        your delivery date, and you won’t pay a cent for shipping. If you have
        an outstanding order and you spot a few more irresistible bottles, you
        can easily add them to your shipment.
      </p>
      <p>
        As you may remember from high school government classes, each state has
        its own laws&mdash;and those extend to alcoholic beverage shipments. We
        apologize, but until local shipping laws change, we cannot ship to all
        states.
      </p>
      <p>
        If you live in one of these states, there are options. If you have a
        friend or family member in a neighboring state, especially one who you
        may be visiting soon, we are happy to ship your order to their address.
        Secondly, we would be happy to ship your order directly to a FedEx or
        UPS store location in a nearby state where we are legally able to ship
        wines for you to pick-up.
      </p>
      <p>
        Regardless of where your wine is being shipped, it’s our top priority to
        ensure that your wines arrive in pristine condition. We source every
        Wine Access offer directly from the winery, guaranteeing that the wine
        you purchase is the wine in the bottle&mdash;no shady middlemen or
        questionable sources, ever.
      </p>
      <p>
        From there, we guard your wines from damaging light and temperature
        fluctuations through every step of the shipping process, from storage in
        our climate-controlled cellars, to avoiding overly hot or cold
        environments by monitoring weather patterns in specific zip codes, to
        adjustable delivery dates that allow you to
        <a class="underline" href="/perfect-provenance/"
          >avoid hot summer shipping.</a
        >
      </p>
      <p>
        Wine shipping is complicated, but we want you to know we’re here to
        help. Our Napa-based member services team is happy to answer any
        questions you may have, and to help get great wines to your
        door&mdash;or a door near you.
      </p>
      <p v-if="passageOfTitleStatement">
        Please call at <CustomerServicePhoneLink :with-hours-long="true" /> if
        you'd like to arrange your own shipment or pickup option.
      </p>
    </section>
  </div>
</template>

<script>
import ShippingMap from '#common/components/Shipping/ShippingMap.vue'
import ShippingStates from '#common/components/Shipping/ShippingStates.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'WhereWeShip',
  components: { ShippingStates, ShippingMap },
  head: {
    title: 'Wine Access - Where We Ship',
    meta: [
      {
        hid: 'description',
        name: 'description',
        content:
          "If you happen to live in a state we don't ship to, there is a workaround. You can have your Wine Access order shipped to friends, family, or a FedEx / UPS pickup location in a state where shipping is permitted. https://www.wineaccess.com/wineries/,Browse wines from the world's best wineries and find the lowest price.",
      },
    ],
  },
  computed: {
    ...mapGetters(['cart']),
    passageOfTitleStatement() {
      return this.cart.passage_of_title_statement
    },
  },
  mounted() {
    this.$store.dispatch('getCart')
  },
  created() {
    this.metadata = useMetadata()
  },
}
</script>

<style lang="scss">
.shipping-map {
  display: grid;
  grid-template-columns: calc(200% / 3) 25%;
  grid-row-gap: 1.5rem;
  justify-content: space-between;

  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 71.625rem;

  @media only screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);
    padding-left: 0.9375rem;
    padding-right: 0.9375rem;
  }
}
.where-we-ship-header {
  margin-bottom: 2.5rem;
}
</style>
